import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import "./css/variables.css";
import "./css/extra.css";
// Layouts
import AuthLayout from "./components/AuthLayout";
import SuperAdminLayout from "./superadmin/SuperAdminLayout";
import AdminLayout from "./Admin/AdminLayout";

// Protected Routes
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import Login from "./auth/Login";
import SuccessfulReset from "./auth/Successful";
import ResetPassword from "./auth/ResetPassword";

import SendEmail from "./auth/SendEmail";
import VerifyEmail from "./auth/VerifyEmail";
import Enterprise from "./pages/EnterPrise";
import ActivityLog from "./pages/ActivityLog";
import RoleManagement from "./pages/RoleManagement";
import ModuleManagement from "./superadmin/ModuleMangement";
import UserManagement from "./superadmin/UserManagement";
import UserManagement1 from "./Admin/UserManagement";
import PageTitleUpdater from "./components/PageTitleUpdater";

// Styles
import "./css/SidebarItem.css";
import "./css/Login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import ComingSoon from "./auth/ComingSoon";
// import Notifications from "./users/Notifications";

import "./App.css";
import ProductManagement from "./superadmin/ProductManagement";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SubscriptionManagement from "./superadmin/SubscriptionManagement";
import Dashboard from "./superadmin/Dashboard";

import UserProfileSettings from "./pages/Profile";
import NotFoundPage from "./pages/NotFoundPage";
import HelpPage from "./pages/HelpPage";
import PrimiumpPage from "./pages/PrimiumPage";
import ErrorLog from "./pages/ErrorLog";
import APIManagementAdmin from "./Admin/APIManagementAdmin";
import IPManagementAdmin from "./Admin/IPManagementAdmin";
import VersionHistory from "./pages/VersionHistory";

const AppRoutes = () => {
  return (
    <>
      <PageTitleUpdater />
      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<SendEmail />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/successful" element={<SuccessfulReset />} />
        </Route>

        {/* Super Admin Routes */}
        <Route
          path="/superadmin"
          element={
            <ProtectedRoute>
              <SuperAdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="user-management" element={<UserManagement />} />
          <Route path="enterprise-management" element={<Enterprise />} />
          <Route path="product-management" element={<ProductManagement />} />
          <Route path="role-management" element={<RoleManagement />} />
          <Route path="activity-log" element={<ActivityLog />} />
          <Route path="error-log" element={<ErrorLog />} />
          <Route path="module" element={<ModuleManagement />} />
          <Route path="version-management" element={<VersionHistory />} />
          {/* <Route path="notifications" element={<Notifications />} /> */}
          <Route
            path="subscription-management"
            element={<SubscriptionManagement />}
          />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="profile" element={<UserProfileSettings />} />
          <Route path="getHelp" element={<HelpPage />} />
        </Route>

        {/*  Admin Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="user-management" element={<UserManagement1 />} />
          <Route path="activity-log" element={<ActivityLog />} />
          <Route path="profile" element={<UserProfileSettings />} />
          {/* <Route path="notifications" element={<Notifications />} /> */}
          <Route path="getHelp" element={<HelpPage />} />
          <Route path="api-management" element={<APIManagementAdmin />} />
          <Route path="ip-management" element={<IPManagementAdmin />} />
        </Route>

        <Route path="*" element={<ComingSoon />} />
        <Route path="/premium-page" element={<PrimiumpPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppRoutes />

      <ToastContainer
        position="top-right"
        autoClose={4000}
        closeButton={false} // We added custom close
        hideProgressBar={false}
        newestOnTop={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        limit={1}
      />
    </Router>
  );
};

export default App;
